import React from 'react';
import ReactDOM from 'react-dom/client';
import AppLoader from './AppLoader';
import './styles/index.css';
import './styles/fonts.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppLoader />
  </React.StrictMode>
);
